import { Injectable } from '@angular/core';

import { BaseFacade } from '@common/services/base-facade.service';
import * as RedirectActions from '@common/utils/redirect/redirect.actions';

@Injectable()
export class RedirectFacade extends BaseFacade {
    public redirectAction(url: string): void {
        this.store$.dispatch(RedirectActions.redirect({ url }));
    }
}
